import { Fragment, type FunctionComponent } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import { CaretDownIcon } from "@App/Components/common/Icons";
import { phoneCodes } from "@App/constants/phoneCodes";
import { supportsEmojis } from "@App/utils/supportsEmojis";

export type PhoneInput = {
  country: string;
  number: string | null;
};

export interface PhoneInputProps {
  id?: string;
  type?: string;
  name?: string;
  placeholder?: string;
  value?: PhoneInput;
  className?: string;
  required?: boolean;
  onChange?: (phone: PhoneInput) => void;
  validationMessage?: string;
}

export const PhoneInput: FunctionComponent<PhoneInputProps> = (props: PhoneInputProps) => {
  const onChange = async (event) => {
    props.onChange({
      country: event.target.name === "country" ? event.target.value : props.value.country,
      number:
        event.target.name === props.name
          ? event.target.value.replace(/[^0-9-./]/g, "")
          : props.value.number,
    });
  };

  const showFlags = supportsEmojis();

  return (
    <Fragment>
      <div className="mt-1 relative rounded-md shadow-sm">
        <div className="absolute inset-y-0 left-1 flex items-center">
          <label htmlFor="country" className="sr-only">
            Land
          </label>
          <select
            id="country"
            name="country"
            autoComplete="country"
            onChange={onChange}
            value={props.value.country}
            className=" appearance-none
                            focus:ring-indigo-500 focus:border-indigo-500
                            py-0 pl-3
                            border-transparent
                            bg-transparent text-gray-500 rounded-md cursor-pointer"
          >
            {phoneCodes.map((code) => (
              <option key={code.value} value={code.value}>
                {showFlags ? `${code.flag} ${code.value}` : code.value}
              </option>
            ))}
          </select>
          <CaretDownIcon className={"w-3 h-w"} color={"neutral-500"} />
        </div>
        <input
          className={`
                    border border-neutral-500
                    rounded
                    shadow
                    ${props.validationMessage && "border-error-300 text-error-900 placeholder-error-300 focus:outline-none focus:ring-error-500 focus:border-error-500 "}
                    py-2 pr-3 pl-24 my-2 ${props.className}`}
          id={props.id}
          type={props.type || "text"}
          name={props.name}
          placeholder={props.placeholder}
          required={props.required}
          value={props.value.number ?? ""}
          onChange={onChange}
        />
        {props.validationMessage && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-error-500" aria-hidden="true" />
          </div>
        )}
      </div>
      {props.validationMessage && (
        <p className="mt-1 mb-4 text-sm text-error-600" id={`${props.id}-error`}>
          {props.validationMessage}
        </p>
      )}
    </Fragment>
  );
};
